export default __webpack_public_path__ + "fonts/down-full-arrow.svg";